import { normalize } from './stringCompare'

interface ChannelLike {
  title?: string
}

interface InstitutionLike {
  displayName?: string
}

const hasDistinctChannel = (
  channel?: ChannelLike | null,
  institution?: InstitutionLike | null
) =>
  !!channel?.title &&
  !!institution?.displayName &&
  normalize(channel.title.trim()) !== normalize(institution.displayName.trim())

export default hasDistinctChannel
